import request from '@/utils/request'

// 获取仪表盘统计数据
export function getDashboardStats() {
  return request({
    url: '/api/admin/dashboard/stats',
    method: 'get'
  })
}

// 获取最新活动记录
export function getRecentActivities(limit = 10) {
  return request({
    url: '/api/admin/dashboard/recent-activities',
    method: 'get',
    params: { limit }
  })
}